var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-subheader',_vm._g({staticClass:"text-caption pa-0",staticStyle:{"height":"auto"}},{ ..._vm.listeners, ...(_vm.disabled ? {} : _vm.$listeners) }),[_c('a',{class:[
      _vm.disabled && 'text--disabled',
      ...(!_vm.underlineOnlyOnHover || _vm.hovered ? ['text-decoration-underline'] : []),
      _vm.classes,
    ],domProps:{"textContent":_vm._s(_vm.$i18n.t(_vm.translationPath))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }